import { UserSettingsService } from './../../../../user-settings/user-settings.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import * as $ from 'jquery';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  useAnimation,
} from '@angular/animations';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { noUndefined } from '@angular/compiler/src/util';

@Component({
  selector: 'app-r-q26',
  templateUrl: './r-q26.component.html',
  styleUrls: ['./r-q26.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ26Component implements OnInit {
  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  term_length;
  terms = [];
  messagetype;
  deviceWidth;
  url = environment.api_url;
  buttonText;
  disablebutton = false;
  timer;
  addAddressFlow = false;
  showbutton = true;
  questionNotifyObj;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {
    processCompleted: '',
    showNotification: '',
  };
  question_q1;
  isRenewal = false;
  display = 'none';

  private actualUtilityName = {
    AEPTexasCentral: 'AEPC',
    AEPTexasNorth: 'AEPN',
    TexasNewMexicoPower: 'TNMP',
    CenterPointEnergy: 'CenterPoint',
    Oncor: 'Oncor',
    AEPC : 'AEPC',
    TNMP: 'TNMP',
    CenterPoint:'CenterPoint',
    AEPN: 'AEPN',
    LPL:'LPL'

  };

  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private http: HttpClient,
    private recommendationService: RecommendationService,
    private userSettingsService: UserSettingsService
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    if (
      this.residentialService.service === 'New Service' ||
      this.residentialService.questionFlowType === 'renewal'
    ) {
      this.buttonText = 'FINISH';
    } else {
      this.buttonText = 'NEXT';
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  getUniqueValuesFromArray(itemValue) {
    return itemValue.filter((row, i) => itemValue.indexOf(row) === i);
  }

  getTerms() {
    const utilityName =  this.getUtilityNameFromQuestionnaire();
    let userObj = {
      UtilityName:
        this.actualUtilityName[
          utilityName.indexOf('(') !== -1
            ? utilityName
                .substring(0, utilityName.indexOf('('))
                .replace(/\s/g, '')
                .replace(/-/g, '')
            : utilityName.replace(/\s/g, '')
        ],
    };
    this.http
      .post(this.url + '/getTermEnergyProviders', userObj)
      .subscribe((res: any) => {
        
        const result = res;
        const dropDownValues = this.getUniqueValuesFromArray(
          result.map((term) => term.Term.toString())
        );
        this.terms = this.sortValues(dropDownValues);
        this.terms.push('Compare All');

        const terms = _.findWhere(this.userResponses, {
          res_question_id: '0026',
        });

        if(terms != undefined && terms != null && ( terms.fieldValue != '' || terms.fieldValue != null )  )
        {

          if(this.terms.filter(x => x == terms.fieldValue).length == 1)
          {
            this.term_length = terms.fieldValue;
            this.showTip = true;
            this.user_bot = true;

            if (_.isEmpty(this.term_length))
            {
              this.showbutton = false;
            }else
            {
              this.showbutton = true;
              this.goNext();
            }
          }
   
        }

       
      });
  }

  sortValues(itemValue) {
    return _.sortBy(itemValue, function (item) {
      return Number(item);
    });
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
          this.isRenewal = true;
        }
        this.index = i;
      }
    }
    if (
      this.deviceWidth > 768 &&
      this.residentialService.questionFlowType !== 'renewal'
    ) {
      const splitQuestion = this.question.split('contract ');
      this.question = splitQuestion[0] + 'contract';
      this.question_q1 = splitQuestion[1];
    }
    this.getTerms();
    this.messagetype = this.residentialService.messervicetype;

    if (_.isEmpty(this.term_length))
            {
              this.showbutton = false;
            }


            if(this.deviceWidth < 768)
            {
              setTimeout(function(){
        
                $('ng-select:visible').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
          
              },500)
            }
        
  }

  getTerm(event) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({ currentId: this.data });
    }
    this.term_length = event;

    if (
      this.term_length === '1 Months' ||
      this.term_length === '30 Months' ||
      this.term_length === '48 Months'
    ) {
      this.term_length = '6 Months';
    }
    this.showTip = true;
    this.user_bot = true;
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
     
        if(!this.showbutton)
        {
          this.next();
        }
      
    }
  }
  next() {
    if (_.isEmpty(this.term_length)) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.save();
      const serviceType = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      if (
        serviceType.fieldValue === 'New Service' ||
        this.residentialService.questionFlowType === 'renewal'
      ) {
        this.residentialService.setStatus('Completed');
        sessionStorage.setItem(
          'questionStatusObj',
          JSON.stringify(this.residentialService.questionnaireStatusObj)
        );
        const questionObj = this.residentialService.questionnaireStatusObj;
        const questionnarieObj = this.residentialService.userResponse;
        const hg_accountId = window.location.href.split('/').pop();
        const user = {
          _id: hg_accountId,
          accountId: hg_accountId,
          questionStatusObj: questionObj,
        };
        const url = window.location.href;
        const urlArr = url.split('/');
        if (
          (!_.isEmpty(this.residentialService.user) &&
            _.isEmpty(this.residentialService['user']['questionStatusObj'])) ||
          (!_.isEmpty(this.residentialService.user) &&
            !_.isEmpty(this.residentialService['user']['questionStatusObj']) &&
            this.residentialService['user']['questionStatusObj']
              .questionStatus === 'Quitted')
        ) {
          this.residentialService['user']['questionStatusObj'] = questionObj;
        }
        if (
          urlArr &&
          urlArr.length !== 0 &&
          urlArr[4] === 'residentialQues' &&
          (urlArr[5] === 'add-address' || urlArr[5] === 'renewal')
        ) {
          this.addAddressFlow = true;
          this.residentialService.user = user;
          this.residentialService.questionFlowType = urlArr[5];
        }
        if (
          urlArr[5] === 'renewal' ||
          this.addAddressFlow ||
          this.residentialService.user
        ) {
         
          this.router.navigateByUrl('/pre-success');
        } else {
         
          this.router.navigateByUrl('/pre-success');
        }
      } else {
        // To handle the 'Prepaid' option
        if (this.term_length === 'PrePaid') {
          this.residentialService.setNextTermId({
            termValue: this.term_length,
            nextId: '0027',
          });
          this.residentialService.messageService({
            currentId: this.data,
            nextId: '0027',
          });
        } else {
          this.residentialService.messageService({
            currentId: this.data,
            nextId: '0028',
          });
        }
      }
    }
  }

  save() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'term_length',
      fieldValue: this.term_length,
    };
    this.residentialService.updateResponses(Obj);
  }

  getUtilityNameFromQuestionnaire() {
    const itemValue = _.findWhere(this.userResponses, {
      res_question_id: '008',
    });
    return itemValue.fieldValue.utility;
  }
}
